import axios from "axios";
import { API } from "../../../../config";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../../../configureStore";
import {
  RoleOption,
  RoleOptionRaw,
} from "../../../../redux/slices/users/managerCreation";
import { OrgGeoPointData } from "../../locations/locationsTypes";

export const fetchRoles = createAsyncThunk(
  "CreateManagerReducer/fetchRoles",
  async (token: string, store) => {
    const { locale } = (store.getState() as RootState).LayoutReducer;

    try {
      const response = await axios.get(
        `${API}/users/user-facing-group-template?$eager=[name.[localizedTexts.locale], desc.[localizedTexts.locale]]&$limit=10000`,
        {
          headers: {
            "Accept-Language": `${locale}`,
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const roles: RoleOption[] = (response.data.data as RoleOptionRaw[])
        .map((r) => ({
          id: String(r.id),
          slug: r.slug,
          name: r.nameTextIdLocale,
          desc: r.descTextIdLocale,
          groupTemplateIds: r.groupTemplateIds,
        }))
        .filter((r) => r.id === "4" || r.id === "3");

      return store.fulfillWithValue(roles);
    } catch (error) {
      return store.rejectWithValue(error);
    }
  },
);

export const fetchGroups = createAsyncThunk(
  "CreateManagerReducer/fetchGroups",
  async (token: string, store) => {
    const { locale } = (store.getState() as RootState).LayoutReducer;
    try {
      const response = await axios.get(
        `${API}/users/organization-group?typeId=112&$eager=[memberships.[user,geoPoint]]&$limit=10000`,
        {
          headers: {
            "Accept-Language": `${locale}`,
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const { data } = response;
      const filterGroups = data.data.filter(
        (group: any) => group.typeId === 112 && !group.isAutoGenerated,
      );

      const newGroupObject = filterGroups.map((g: any) => ({
        createdAt: g.createdAt,
        deletedAt: g.deletedAt,
        groupTemplateId: g.groupTemplateId,
        id: g.id,
        isAutoGenerated: g.isAutoGenerated,
        name: g.name,
        orgId: g.orgId,
        typeId: g.typeId,
        updatedAt: g.updatedAt,
        locations: g.memberships
          .filter((memberships: any) => memberships.geoPoint !== null)
          .map((d: any) => d.geoPointId),
      }));

      return store.fulfillWithValue(newGroupObject);
    } catch (error) {
      return store.rejectWithValue(error);
    }
  },
);

export const fetchLocations = createAsyncThunk(
  "CreateManagerReducer/fetchLocations",
  async (token: string, store) => {
    const { locale } = (store.getState() as RootState).LayoutReducer;
    const queryParams = `/users/organization-geo-point?$eager=[groupMemberships.group, type, names]&deletedAt=null&$limit=10000`;

    try {
      const response = await axios.get(`${API}${queryParams}`, {
        headers: {
          "Accept-Language": `${locale}`,
          Authorization: `Bearer ${token}`,
        },
      });
      const { data } = response;

      const locations = data.data
        .map((loc: OrgGeoPointData) => ({
          id: loc.id,
          name: loc.name,
          shared: loc.shared ?? false,
        }))
        .filter((loc: OrgGeoPointData) => loc.shared !== true);

      return store.fulfillWithValue(locations);
    } catch (error) {
      return store.rejectWithValue(error);
    }
  },
);
